import React from 'react';
import { FaStar } from 'react-icons/fa';

const StarRating = ({ rating, setRating, hover, setHover }) => {
  return (
      <div className="flex justify-center items-center gap-2" role="radiogroup" aria-label="Star rating">
        {[...Array(5)].map((_, i) => {
          const ratingValue = i + 1;
          return (
              <label
                  key={ratingValue}
                  className="cursor-pointer transition-colors duration-200 flex items-center focus:outline-none focus:ring-2 focus:ring-yellow-400 rounded"
                  aria-checked={rating === ratingValue}
                  role="radio"
                  tabIndex={0}
              >
                <input
                    type="radio"
                    name="rating"
                    value={ratingValue}
                    onClick={() => setRating(ratingValue)}
                    className="hidden"
                    aria-label={`${ratingValue} Star${ratingValue > 1 ? 's' : ''}`}
                />
                <FaStar
                    size={40}
                    color={ratingValue <= (hover || rating) ? "#FFD600" : "#E4E5E9"}
                    onMouseEnter={() => setHover(ratingValue)}
                    onMouseLeave={() => setHover(null)}
                    className="transition-transform duration-150 hover:scale-110"
                />
              </label>
          );
        })}
      </div>
  );
};

export default StarRating;
